import { render } from "./HomeForm.vue?vue&type=template&id=cc56ff0a&scoped=true"
import script from "./HomeForm.vue?vue&type=script&lang=js"
export * from "./HomeForm.vue?vue&type=script&lang=js"

import "./HomeForm.vue?vue&type=style&index=0&id=cc56ff0a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc56ff0a"]])

export default __exports__